module.exports = __webpack_public_path__ + "img/mo.acc65fd.svg";